<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>

<div class="main-div">
    <div class="left-div">
        <p class="text1">CASUAL</p>
        <p class="text2">GAMERS</p>

        <p class="text3">
            More into occasional matching of bejewels, popping of virtual
            balloons and restaurant simulation games? <br /> <br />

            Juggling your daily routine, job and family alongside an unrealized
            passion for games that you just didn’t have the time to grow into a
            serious hobby?
        </p>

        <p class="text4">
            Escape into the dynamic world created by players like you, tailored
            for injecting fun into a busy life. We’re building the future of
            casual gaming narrated and produced by players like you. Step into
            it.
        </p>
        <div class="btn">
            <DesktopButton2 
            state = "Games"/>
        </div>
    </div>

    <div class="right-div">
        <img
            src="/images/Gamer/controller.png"
            width="100%"
            height="100%"
            alt=""
        />
    </div>
</div>

<style>
    .main-div {
        display: flex;
        height: 100vh;
        overflow: hidden;
        justify-content: space-between;
    }
    .left-div {
        margin-left: 11.944vh;
        width: 53vh;
        padding-top: 16.759vh;
    }
    p {
        font-family: "Orbitron";
    }
    .text1 {
        font-size: 7.407vh;
        line-height: 7.407vh;
        color: #615bff;
        font-weight: 700;
        margin: 0;
    }
    .text2 {
        padding-left: 15.463vh;
        font-size: 7.407vh;
        line-height: 7.407vh;
        color: #615bff00;
        font-weight: 700;
        -webkit-text-stroke: 0.185vh black;
        margin: 0;
    }
    .text3 {
        font-size: 1.481vh;
        color: black;
        line-height: 2.074vh;
        width: 52vh;
        font-weight: 400;
        letter-spacing: 0.04vh;
        margin-top: 9.093vh;
    }
    .text4 {
        font-size: 1.852vh;
        color: black;
        width: 51.333vh;
        font-weight: 700;
        line-height: 2.593vh;
        margin-top: 5.278vh;
        letter-spacing: 0.04vh;
    }
    .right-div {
        width: 119.222vh;
        height: 99.5vh;
        transform: scale(1.05) translate(-1vh, -2vh);
    }
    .btn {
        margin-top: 7.13vh;
    }
    .right-div::after{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
</style>
